import Resource from '@/api/resources/Resource'

class LanguageService extends Resource {
    async findAllActiveAndUiEnabled() {
        const response = await this.axios.get(`/common/languages/ui/index`)
        return response.data
    }

    async findAllActiveAndReportingEnabled() {
        const response = await this.axios.get(`/common/languages/reporting/index`)
        return response.data
    }
}

export default new LanguageService()
